import { fromJS, Map } from 'immutable';
import types from '../constants/notifConstants';

const INITIAL_STATE = {
  successMsg: null,
  failedMsg: null,
  msgTo: {
    data: null,
    isLoading: true,
  },
  msgToDetail: {
    data: null,
    isLoading: false,
    hasError: false,
  },
  msgFrom: {
    data: null,
    isLoading: true,
  },
  msgFromDetail: {
    data: null,
    isLoading: false,
    hasError: false,
  },
  activeTime: null,
  notifcation: null,
  active_notification: [],
  lastToListQuery: null,
  lastFromListQuery: null,
};

const initialImmutableState = fromJS(INITIAL_STATE);

const notificationReducer = (state = initialImmutableState, action = {}) => {
  switch (action.type) {
    case types.SUCCESS_NOTIF:
      return state.withMutations((mutableState) => {
        mutableState.set('successMsg', fromJS(action.payload));
      });
    case types.FAILED_NOTIF:
      return state.withMutations((mutableState) => {
        mutableState.set('failedMsg', fromJS(action.payload));
      });
    case types.GET_NOTIF_TO:
      return state.withMutations((mutableState) => {
        if (action.payload) {
          mutableState.set('lastToListQuery', fromJS(action.payload));
        }
        mutableState.updateIn(['msgTo'], (msgTo = Map()) => msgTo.set('isLoading', true));
      });
    case types.SET_NOTIF_TO:
      return state.withMutations((mutableState) => {
        mutableState.set('msgTo', fromJS({ ...action.payload, isLoading: false }));
      });
    case types.GET_NOTIF_TO_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['msgToDetail'], (msgToDetail = Map()) =>
          msgToDetail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_NOTIF_TO_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'msgToDetail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_NOTIF_TO_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('msgToDetail', fromJS({ data: null, isLoading: false, hasError: true }));
      });
    case types.GET_NOTIF_FROM:
      return state.withMutations((mutableState) => {
        if (action.payload) {
          mutableState.set('lastFromListQuery', fromJS(action.payload));
        }
        mutableState.updateIn(['msgFrom'], (msgFrom = Map()) => msgFrom.set('isLoading', true));
      });
    case types.SET_NOTIF_FROM:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'msgFrom',
          fromJS({
            ...action.payload,
            isLoading: false,
          }),
        );
      });
    case types.GET_NOTIF_FROM_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['msgFromDetail'], (msgFromDetail = Map()) =>
          msgFromDetail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_NOTIF_FROM_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'msgFromDetail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_NOTIF_FROM_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('msgFromDetail', fromJS({ data: null, isLoading: false, hasError: true }));
      });
    case types.SET_ACTIVITY_TIME:
      return state.withMutations((mutableState) => {
        mutableState.set('activeTime', fromJS(action.payload));
      });
    case types.SET_NOTIFICATION:
      return state.withMutations((mutableState) => {
        mutableState.set('notfication', fromJS(action.payload));
      });
    default:
      return state;
  }
};

export default notificationReducer;
